import React from 'react'

function Footer() {
  return (
    <div className='footer-section'>
        <a href="https://luminai.ai"><li>Website</li></a>
        <a href="https://academy.luminai.ai"><li>Academy</li></a>
        <a href="https://whitepaper.luminai.ai"><li>Whitepaper</li></a>
    </div>
  )
}

export default Footer;